module.exports = __webpack_public_path__ + "img/图片16.e2f05486.png";